import { Box, withStyles } from '@material-ui/core';

export const ScrollBox = withStyles(() => ({
  root: {
    overflowX: 'auto',
    display: 'flex',
  },
}))(Box);

export const MinWidthBox = withStyles(() => ({
  root: {
    width: '100%',
  },
}))(Box);
